<template>
  <intro-template
    @start="next"
    button-label="Commencer l'activité">
    <template v-slot:module-title>
      Consulter les congés et heures de récup
    </template>
    <template v-slot:learnings-title>
      Dans ce module, vous allez apprendre à...
    </template>
    <template v-slot:learnings>
      <p>Consulter le planning de votre équipe sur la GTA</p>
      <p>Piloter et anticiper les présences/absences de votre équipe et le stock d’heures</p>
    </template>
    <template v-slot:rules>
      <div class="rule">
        <p class="label">
          Trouvez
        </p>
        <p class="value">
          la signification des sigles utilisés en GTA
        </p>
      </div>
      <div class="rule">
        <p class="label">
          Localisez
        </p>
        <p class="value">
          les informations utiles au pilotage de votre agence sur la GTA
        </p>
      </div>
    </template>
  </intro-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'

export default {
  name: 'Intro',
  mixins: [stepMixin]
}
</script>
